import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next'
import BuilderFieldAttr from '../BuilderFieldAttr'
import { getLayoutAttr } from "../../selectors/entities/general";

class BuilderAttr extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      openDetailPopup: false,
    }
  }

  openDetailPopup = () => {
    this.setState({ openDetailPopup: true })
  }
  closeDetailPopup = () => {
    this.setState({ openDetailPopup: false })
  }


  render() {
    const { section } = this.props;
    return (
      <section className="b-rit-section">
        <div className={'config-header'}>
          <h5 className={'heading'}>
            {section.displayName}
          </h5>
        </div>
        <BuilderFieldAttr
          sectionName={this.props.sectionName}
        />
      </section>
    );
  }
}

BuilderAttr.propTypes = {
  section: PropTypes.object.isRequired,
  sectionName: PropTypes.string.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    section: getLayoutAttr(state, ownProps.sectionName),
  };
}

export default connect(
  mapStateToProps,
  null
)(withTranslation()(BuilderAttr));